import React from 'react';
import './styles/how-it-works.css';
import { useNavigate } from 'react-router-dom';

const HowItWorks = () => {

  const navigate = useNavigate();

  const handleGetStarted = () => {
    navigate('/');
    setTimeout(() => {
      const element = document.querySelector('.registration-section');
      if (element) {
        const headerOffset = 100;
        const elementPosition = element.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.pageYOffset - headerOffset;
        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth'
        });
      }
    }, 100);
  };

  return (
    <div className="how-it-works-page">
      {/* Hero Section */}
      <section className="hiw-hero">
        <h1>Professional FBA Prep Center in Florida</h1>
        <p className="hiw-subtitle">Your Trusted Partner for Amazon & E-commerce Fulfillment</p>
        <p className="hiw-description">
          Precise Prep Services offers comprehensive prep center solutions for Amazon FBA, Walmart, eBay, 
          Etsy, Shopify, TikTok, Instagram and orders from your own website. We handle everything from 
          receiving and inspection to labeling and shipping, so you can focus on growing your business.
        </p>
      </section>

      {/* Steps Section */}
      <section className="hiw-steps">
        <div className="steps-container">
          <h2 className="section-title">How It Works</h2>
          
          <div className="step">
            <div className="step-number">1</div>
            <div className="step-content">
              <h3>Complete Registration Form</h3>
              <p>
                Streamline your onboarding process by completing the registration form. Provide essential 
                details effortlessly and unlock a world of opportunities with just a few simple steps.
              </p>
            </div>
          </div>

          <div className="step">
            <div className="step-number">2</div>
            <div className="step-content">
              <h3>Ship Your Inventory</h3>
              <p>
                Send your inventory to Precision Prep. Our base fee of $0.75/unit covers receiving, 
                inspection, photo documentation of any damage, and meticulous labeling and packaging 
                for shipment. Additional preparation services may have varying prices depending on your needs.
              </p>
            </div>
          </div>

          <div className="step">
            <div className="step-number">3</div>
            <div className="step-content">
              <h3>Payment Process</h3>
              <p>
                After receiving the shipping label from you, we will initiate the billing process. 
                You will receive it on your email.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Why Choose Us */}
      <section className="hiw-benefits">
        <div className="benefits-grid">
        <div className="benefit-card">
            <div className="benefit-icon">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <rect x="3" y="3" width="18" height="18" rx="2"/>
                <path d="M3 9h18"/>
                <path d="M9 21V9"/>
            </svg>
            </div>
            <h3>Secure Storage</h3>
            <p>
            Flexible warehouse storage solutions at minimal cost. Divide shipments and easily 
            replenish Amazon stock as needed.
            </p>
        </div>

        <div className="benefit-card">
            <div className="benefit-icon">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>
            </svg>
            </div>
            <h3>Prompt Communication</h3>
            <p>
            Effective communication via phone, email, or text. Every client is treated as a 
            valued partner for the best service.
            </p>
        </div>

        <div className="benefit-card">
            <div className="benefit-icon">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <circle cx="11" cy="11" r="8"/>
                <path d="m21 21-4.35-4.35"/>
            </svg>
            </div>
            <h3>Accurate Inspection</h3>
            <p>
            Thorough inspection services. All defects, damages, or concerns are documented 
            and communicated immediately.
            </p>
        </div>

        <div className="benefit-card">
            <div className="benefit-icon">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <circle cx="12" cy="12" r="10"/>
                <polyline points="12 6 12 12 16 14"/>
            </svg>
            </div>
            <h3>Strict Deadlines</h3>
            <p>
            Swift service and tight deadline adherence. Prompt results delivered without 
            compromising quality.
            </p>
        </div>

        <div className="benefit-card">
            <div className="benefit-icon">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M12 20h9"/>
                <path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z"/>
            </svg>
            </div>
            <h3>Customized Solutions</h3>
            <p>
            Tailored solutions for unique business requirements. We collaborate to offer 
            optimal prep center services.
            </p>
        </div>

        <div className="benefit-card">
            <div className="benefit-icon">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <polyline points="22 12 18 12 15 21 9 3 6 12 2 12"/>
            </svg>
            </div>
            <h3>Business Growth</h3>
            <p>
            Focus on growth while we handle packaging and preparation. Scale your business 
            with our efficient services.
            </p>
        </div>
        </div>
      </section>

      {/* CTA */}
      <div className="hiw-cta">
        <button onClick={handleGetStarted} className="get-started-btn">
          Get Started
        </button>
      </div>
    </div>
  );
};

export default HowItWorks;